import css from '@styled-system/css'
import styled from 'styled-components'
import { H6, P } from 'ui/bend'

export const H6Title = styled(H6)(() =>
  css({
    color: '#000',
    fontSize: '16px',
    fontWeight: '700',
    textTransform: 'capitalize'
  })
)

export const Desc = styled(P)(() =>
  css({
    color: '#000',
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.308px'
  })
)
